import { render, staticRenderFns } from "./ThgProducts.vue?vue&type=template&id=7337822a&scoped=true"
import script from "./ThgProducts.vue?vue&type=script&lang=ts"
export * from "./ThgProducts.vue?vue&type=script&lang=ts"
import style0 from "./ThgProducts.vue?vue&type=style&index=0&id=7337822a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7337822a",
  null
  
)

export default component.exports